export const CurrentRelease = {
        getReleaseData() {
            return Promise.resolve([
            { database: 'UniProtKB', version: 'v2026_01/2026-04'},
            { database: 'InterPro', version: 'v108.0/2026-04' },
            { database: 'PFAM', version: 'v38.1/2026-04' },
            { database: 'IntAct', version: 'v2026-01-14/2026-04'},
            { database: 'PhosphoSitePlus®', version: 'v2025-04-18/2026-04' },
            { database: 'Clinvar', version: 'v2026-04-26/2026-04' },
            { database: 'AlphaMissense', version: 'v2023-09-13/2026-04' },
            { database: 'AlphaFold Monomer', version: 'v6-2026/2026-04' },
            { database: 'AlphaFold Multimers', version: 'v1-2026/2026-08' },
            { database: 'PDB', version: 'v2026-05-20/2026-05' },
            { database: 'SIFTS (PDB residue mapping)', version: 'v2026-05-20/2026-05' },
        ]);
      }
};